export enum Title {
    DR = 'Dr.',
    PROF = 'Prof.',
    PROFDR = 'Prof. Dr.'
}